import cx from 'classnames'
import Styles from './BatchModals.module.scss'
import { VideoDuration } from 'components/VideoDuration/VideoDuration'
import { Pressable } from '@react-aria/interactions'
import { useHover } from '@react-aria/interactions'

interface Props {
  src?: string
  alt?: string
  onRemove?: () => void
  duration?: number
  size?: string
  closeCoordinates?: { top: string; right: string }
}

export const Image = ({
  src,
  alt = '',
  onRemove,
  duration,
  size = '70px',
  closeCoordinates = { top: '5px', right: '5px' },
}: Props) => {
  let { hoverProps: containerHoverProps, isHovered: containerIsHovered } = useHover({})
  let { hoverProps: removeButtonHoverProps, isHovered: removeButtonIsHovered } = useHover({})

  return (
    <div className={Styles.imageContainer} {...containerHoverProps} style={{ width: size, height: size }}>
      <img src={src} alt={alt} style={{ width: size, height: size }} />
      {containerIsHovered && (
        <Pressable onPress={onRemove}>
          <div
            className={cx(Styles.removeImageButton, { [Styles.hovered]: removeButtonIsHovered })}
            {...removeButtonHoverProps}
            style={closeCoordinates}
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
              <path
                d="M10.6668 5.33337L5.3335 10.6667M10.6668 10.6667L5.3335 5.33337"
                stroke="black"
                strokeOpacity="0.8"
                strokeWidth="1.5"
                strokeLinecap="round"
              />
            </svg>
          </div>
        </Pressable>
      )}
      {duration && <VideoDuration duration={duration} />}
    </div>
  )
}
